import React from 'react';
import { useSelector } from "react-redux";
import './articles.styles.scss';

const Articles = () => {
  const xprops = useSelector(state => state);
  return(
    <React.Fragment>
      <div id="makalelerIDWrapper">
        <div className="articlesSectionWrapper">
          <div className="articleItem">
            <img className="blogContentLogoImg" src="/assets/images/sessiz-olmaz-logo.png" alt="BLOG"/> 
            <a href='https://www.sessizolmaz.org' className='articleTitleLink'><h2 className="articleItemTitle">BLOG</h2></a>
            <p className="articleItemContent">
              {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                  Sessiz Olmaz başlıklı blog sayfasında toplumsal cinsiyet eşitliği ana teması altında farklı alanlarda yazılar okuyucularla paylaşılıyor ve sosyal medya hesaplarında konuyla ilgili farkındalık yaratmak için içerikler üretiliyor. 
                  <br/><br/>
                  Blog sayfasına uzmanlık alanınızdan bir yazı ile katkıda bulunmak isterseniz bizimle temasa geçebilirsiniz.                   
                </React.Fragment> :
                <React.Fragment>
                  On the Sessiz Olmaz blog page, articles are shared with readers under the main theme of gender equality, and content is produced to raise awareness on social media platforms.
                  <br/><br/>
                  If you would like to contribute an article from your area of expertise, please get in touch with us.
                </React.Fragment>
              }
            </p> 
          </div>
          <div className="articleItem">
            <img className="blogContentBlogImg" src="/assets/images/sessiz-olmaz-blog.jpg" alt="SENSİZ OLMAZ SESSİZ OLMAZ BLOG"/>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Articles;
